// libs
import "babel-polyfill";
import $ from "jquery";
import Barba from "./libs/barba"
import {breakpoint, breakpointDown, breakpointOnly} from "./libs/Breakpoints";
import Menu from "./libs/menu"


// Init Js
$(document).ready(() => {
    // Add body class if IE11
    if(navigator.userAgent.match(/Trident.*rv:11\./)) {
        $('body').addClass('ie11');
        $('html').addClass('ie11');
    }else{
        $('#styles-aos-css').attr('href', $('#styles-aos-css').data('href'))
    }
    // Update body classList
    $("body")[0].classList.value = $("main")[0].classList.value;

    breakpoint.init();
    Barba.init();
    Menu.init();

    //CookieBanner.init();

    let firstInit = true
    let beforeReso = breakpoint.value

    $(window).bind("resizeEnd", () => {

        if (!firstInit && breakpointDown("md") && beforeReso !== breakpoint.value && $('body').hasClass('home')) {
            location.reload();
        } else {
            firstInit = false
            beforeReso = breakpoint.value
        }

    });



});

